export const Estilos = (app) => {
    return {
        Estilos: {
            px(val) {
                return `${val}px`
            },

            perc(val) {
                return `${val}%`
            },

            getStyle(element) {
                var cs = window.getComputedStyle ? window.getComputedStyle(element) : getComputedStyle(element);

                var paddingLeft = parseFloat(cs.paddingLeft);
                var paddingRight = parseFloat(cs.paddingRight);
                var paddingTop = parseFloat(cs.paddingTop);
                var paddingBottom = parseFloat(cs.paddingBottom);

                var paddingX = paddingLeft + paddingRight;
                var paddingY = paddingTop + paddingBottom;

                var borderLeft = parseFloat(cs.borderLeftWidth);
                var borderRight = parseFloat(cs.borderRightWidth);
                var borderTop = parseFloat(cs.borderTopWidth);
                var borderBottom = parseFloat(cs.borderBottomWidth);


                var borderX = borderLeft + borderRight;
                var borderY = borderTop + borderBottom;

                // Element width and height minus padding and border
                var elementWidth = element.offsetWidth - paddingX - borderX;
                var elementHeight = element.offsetHeight - paddingY - borderY;

                return {
                    element: element,
                    id: element.id,
                    classList: [...element.classList],
                    height: elementHeight,
                    outerHeight: element.offsetHeight,
                    width: elementWidth,
                    outerWidth: element.offsetWidth,
                    padding: {
                        top: paddingTop,
                        bottom: paddingBottom,
                        left: paddingLeft,
                        right: paddingRight
                    },
                    border: {
                        top: borderTop,
                        bottom: borderBottom,
                        left: borderLeft,
                        right: borderRight
                    },
                    window: {
                        width: window.innerWidth,
                        height: window.innerHeight
                    }
                }
            },

            loadCSS(seletor, com_propriedade_obrigatoria) {
                var sheets = document.styleSheets;
                seletor = seletor.split(' ').join('');
                for (var s of sheets) {
                    var rules = [];
                    try {
                        rules = s.rules || s.cssRules;
                    }
                    catch {}                
                    for (var r of rules) { 
                        if ((r.selectorText || '').split(' ').join('').includes(seletor)) {
                            if ((!!r.style) && r.style[com_propriedade_obrigatoria])
                                return r.style
                        }
                    }
                }
                return undefined;
            },

            loadCssPropriedade(seletor, propriedade, padrao) {
                var style = this.loadCSS(seletor, propriedade);
                return style ? style[propriedade] : padrao;
            },
            coresPorClasse: {},
            getCorFundoPorClasse(classe) {
                let corClasse = this.coresPorClasse[classe+app.config.globalProperties.$store.getters.tema]
                if (corClasse)
                    return corClasse
                const divElem = document.createElement('div');
                divElem.classList.add(classe);
                document.body.appendChild(divElem);
                const computedStyle = getComputedStyle(divElem);
                const backgroundColor = computedStyle.backgroundColor;
                divElem.remove();
                this.coresPorClasse[classe+app.config.globalProperties.$store.getters.tema] = backgroundColor
                return backgroundColor;
            },

            corDoFundoSelecao() {
                if (app.config.globalProperties.$store.getters.tema == 'tema-dark')
                    return this.loadCssPropriedade(`.dx-swatch-vistra-dark .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td`, 'background-color')
                return this.loadCssPropriedade('.dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td', 'background-color')
            },

            corTexto() {
                return this.getCorFundoPorClasse('dx-theme-text-color-as-background-color')
            },

            corFundo() {
                return this.getCorFundoPorClasse('dx-theme-background-color')
            },

            corTema() {
                return this.getCorFundoPorClasse('dx-theme-accent-as-background-color')
            },

            corBorda() {
                return this.getCorFundoPorClasse('dx-theme-border-color-as-background-color')
            }       
        }
    }
}